<template>

<div>
	<div id="dashboard-analytics">                                                        
		<div class="vx-row">                                                                  
		
		  <!-- WELCOME CARD -->	
		  <!-- <div class="vx-col w-full lg:w-1/2 mb-base">                                                                                 
			<vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">       
			  <feather-icon icon="HomeIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>                                    
			  <h1 class="mb-6 text-white" v-if="gender == 2">{{ $t('Welcome_F') }} {{$user.name}}</h1>                         
			  <h1 class="mb-6 text-white" v-else>{{ $t('Welcome_M')}} {{$user.name}}</h1>                         
			  <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Bem-vindo ao Vila Galé Ericeira, para mais informações consulte o nosso <a href="/geral/directorio" style="color: white"><u>directório</u></a>.</p>
			</vx-card>                              
		  </div>  -->
		</div>
		<div class="vx-row">
			<div class="vx-col w-full lg:w-1/2 mb-base">
				<div class="vx-card text-center greet-user" slot="no-body" style="min-height: 233px;background: linear-gradient(118deg,rgba(var(--vs-primary),1),rgba(var(--vs-primary),.5));color: rgb(255, 255, 255);">
					<div class="vx-card__collapsible-content vs-con-loading__container">
						<div class="vx-card__body">
							<img :src="require(`@/assets/images/decore-left.png`)" alt="Decore Left" width="200" style="position: absolute; left: 0; top: 0;">
							<img :src="require(`@/assets/images/decore-right.png`)" alt="Decore Right" width="175" class="decore-right" style="position: absolute; right: 0; top: 0;">
							<span class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow feather-icon select-none relative">
								<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-award h-8 w-8">
									<circle cx="12" cy="8" r="7"></circle>
									<polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
								</svg>
							</span>
							<h2 class="mb-6 text-white" v-if="$user.gender == 1">{{$t('Welcome_M')}} {{user_first_last_name}}</h2>
							<h2 class="mb-6 text-white" v-else>{{$t('Welcome_F')}} {{user_first_last_name}}</h2>
							<a href="//reservas.vilagale.com/engine/search" target="_blank"><button type="button" name="button" class="vs-component vs-button shadow-md w-full lg:mt-0 mt-4 vs-button-primary vs-button-filled includeIcon">
								<span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span><span class="vs-button-text vs-button--text font-bold">RESERVAR</span>
								<span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
							</button></a>
						</div>
					</div>
				</div>
			</div>
			<div v-if="!Array.isArray($user.hotel)" class="vx-col w-full lg:w-1/2 mb-base">
				<div class="vx-card" style="min-height: 233px;">
					<div class="vx-card__header">
						<div class="vx-card__title">
							<h4>{{$t('your_rsv')}}</h4>
						</div>
					</div>
					<div class="vx-card__collapsible-content vs-con-loading__container">
						<div class="flex flex-row justify-between px-8 pb-4 mt-4">
							<p class="text-left">
								<span class="block">Hotel</span>
								<span class="text-2xl font-semibold">{{$user.hotel.hotel_name}}</span>
							</p>
						</div>
						<div class="flex flex-row rsv_data justify-between px-8 pb-4 mt-4">
							<p class="text-center">
								<span class="block">{{$t('rsv_number')}}</span>
								<span class="text-2xl font-semibold">{{$user.hotel.num_reserva}}</span>
							</p>
							<p class="text-center">
								<span class="block">{{$t('room_number')}}</span>
								<span class="text-2xl font-semibold">{{$user.hotel.current_room_number}}</span>
							</p>
							<p class="text-center">
								<span class="block">{{$t('client_account')}}</span>
								<span class="text-2xl font-semibold">{{account_val}}{{$user.hotel.moeda}}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
			<div v-else-if="$user.future_rsv !== null" class="vx-col w-full lg:w-1/2 mb-base">
				<div class="vx-card" style="min-height: 233px;">
					<div class="vx-card__header">
						<div class="vx-card__title">
							<h4>{{$t('your_next_rsv')}}</h4>
						</div>
					</div>
					<div class="vx-card__collapsible-content vs-con-loading__container">
						<div class="flex flex-row justify-between px-8 pb-4 mt-4">
							<p class="text-left">
								<span class="block">Hotel</span>
								<span class="text-2xl font-semibold">{{$user.future_rsv.hvg_desc}}</span>
							</p>
						</div>
						<div class="flex flex-row rsv_data justify-between px-8 pb-4 mt-4">
							<p class="text-center">
								<span class="block">{{$t('rsv_number')}}</span>
								<span class="text-2xl font-semibold">{{$user.future_rsv.num_reserva}}</span>
							</p>
							<p class="text-center">
								<span class="block">Check-In</span>
								<span class="text-2xl font-semibold">{{$user.future_rsv.checkin}}</span>
							</p>
							<p class="text-center">
								<span class="block">Check-Out</span>
								<span class="text-2xl font-semibold">{{$user.future_rsv.checkout}}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="vx-row">
			<div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-base">
				<div class="vx-card" style="height: 233px; min-height: 233px;">
					<div class="vx-card__header">
						<div class="vx-card__title">
							<h4>A Sua Próxima Reserva</h4>
						</div>
					</div>
					<div class="vx-card__collapsible-content vs-con-loading__container">
						<div class="flex flex-row justify-between px-8 pb-4 mt-4">
							<p class="text-left">
								<span class="block">Hotel</span>
								<span class="text-2xl font-semibold">Hotel Vila Galé Collection Palácio dos Arcos</span>
							</p>
						</div>
						<div class="flex flex-row justify-between px-8 pb-4 mt-4">
							<p class="text-center">
								<span class="block">Nº Reserva</span>
								<span class="text-2xl font-semibold">5001157</span>
							</p>
							<p class="text-center">
								<span class="block">Check-In</span>
								<span class="text-2xl font-semibold">15-01-2021</span>
							</p>
							<p class="text-center">
								<span class="block">Check-Out</span>
								<span class="text-2xl font-semibold">20-01-2021</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div> -->
	</div>

	<!-- CORPORATE PHOTO CAROUSSEL -->
	<div id="extra-component-vue-awesome-swiper-demo vx-col corporate-carousel" v-if="corporate_images.PT.length > 0">
		<div class="vx-col w-full mb-base">
			<carousel-multiple-slides-per-view v-bind:corporate_images="corporate_images"></carousel-multiple-slides-per-view>
		</div>
	</div>

	<!-- HOTEL PHOTO CAROUSSEL -->
	<div id="extra-component-vue-awesome-swiper-demo vx-col hotel-carousel" v-if="hotel_images.PT.length > 0">
		<div class="vx-col w-full mb-base">
			<carousel-multiple-slides-per-view v-bind:hotel_images="hotel_images"></carousel-multiple-slides-per-view>
		</div>
	</div>

	<!-- Noticias -->
    <div class="vx-col mb-base" v-if="news_info && Object.keys(news_info).length > 0">
        <vx-card :title="$t('Noticias')" slot="no-body">
            <newsHighlight v-bind:news_info="news_info" v-bind:page="'home'">
            </newsHighlight>
        </vx-card>
    </div>

	<div class="vx-col mb-base" v-if="$user.is_staff">
		<vx-card slot="no-body" class="meteo">
			<EventCalendar></EventCalendar>
		</vx-card>
	</div>


	<!-- WEATHER WIDGET -->
	<div class="vx-col mb-base" v-if="$user.hotel.gps">
		<vx-card slot="no-body" class="meteo">
			<weather></weather>
		</vx-card>
	</div>



	<!-- CHAT CARD -->
	<!-- <div class="vx-col w-full lg:w-1/3 md:w-1/2 sm:w-1/2 chat_card">
		<vx-card title="Recepção" class="overflow-hidden">
			<template slot="no-body">
				<div class="chat-card-log">
					<VuePerfectScrollbar ref="chatLogPS" class="scroll-area pt-6 px-6" :settings="settings">
						<ul ref="chatLog">
							<li class="flex items-start" :class="{'flex-row-reverse': msg.isSent, 'mt-4': index}" v-for="(msg, index) in chatMsg" :key="index">
								<vs-avatar size="40px" class="m-0 flex-no-shrink" :class="msg.isSent ? 'ml-5' : 'mr-5'" :src="require(`@/assets/images/portrait/small/${msg.senderImg}`)"></vs-avatar>
								<div class="msg relative bg-white shadow-md py-3 px-4 mb-2 rounded-lg max-w-md" :class="{'chat-sent-msg bg-primary-gradient text-white': msg.isSent, 'border border-solid border-grey-light': !msg.isSent}">
									<span>{{ msg.msg }}</span>
								</div>
							</li>
						</ul>
					</VuePerfectScrollbar>
				</div>
				<div class="flex bg-white chat-input-container p-6">
					<vs-input class="mr-3 w-full" v-model="chatMsgInput" @keyup.enter="chatMsgInput = ''" placeholder="Escreva a sua mensagem" ></vs-input>
					<vs-button icon-pack="feather" icon="icon-send" @click="chatMsgInput = ''"></vs-button>
				</div>
			</template>
		</vx-card>
	</div> -->

	<!--<div class="vx-row">-->
		<!-- POINT OF INTEREST WIDGET -->
		<!-- <div class="poi">
			<div>
				<vx-card title="Map" class="overflow-hidden">
					<PointsOfInterest></PointsOfInterest>
				</vx-card>	
			</div>
		</div> -->
	<!--</div>-->

	<!-- GOING FOR AN INTRODUCTION POPUP -->
	<vs-popup v-if="welcome_template_tmp" class="introduction_popup w-4/6 mx-auto" :title="$t($user.gender == 1 ? 'Welcome_M' : 'Welcome_F')" :active.sync="welcome_popup">
		<vs-checkbox class="mb-2" v-on:change="hidePopup()">{{$t('dont_show_popup')}}</vs-checkbox>
		<WelcomePopup />
		<vs-checkbox class="mt-2" v-on:change="hidePopup()">{{$t('dont_show_popup')}}</vs-checkbox>
	</vs-popup>
</div>

</template>

<script>

import themeConfig from '@/../themeConfig.js';

// import axios
import axios from 'axios';

import CarouselMultipleSlidesPerView from './components/CarouselMultipleSlidesPerView.vue'
import WelcomePopup from './components/WelcomePopup.vue'
import Weather from './components/Weather.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import PointsOfInterest from './components/PointsOfInterest.vue'
import NewsHighlight from './components/NewsHighlight.vue'
import EventCalendar from './components/EventCalendar.vue'

export default {
	data() {
        return {
			chatMsgInput: '',
			lang: '',
			welcome_popup: true,
			account_val: '0',
			checkBox1: '',
			welcome_template_tmp: false,
			corporate_images: {
				PT: []
			},
			hotel_images: {
				PT: []
			},
			// Perfectscrollbar settings
			settings: {						
				maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            chatMsg: [
                { senderImg: 'avatar-s-2.png', msg: 'Olá senhores da recepção.', isSent: true },
                { senderImg: 'avatar-s-5.png', msg: 'Olá minha querida em que posso ajudar?', isSent: false },
                { senderImg: 'avatar-s-2.png', msg: 'Tenho uma lâmpada fundida no WC.', isSent: true },
                { senderImg: 'avatar-s-5.png', msg: 'Sem problemas, iremos tratar do assunto o mais rápido possível. Aceita um cafézinho?', isSent: false },
                { senderImg: 'avatar-s-2.png', msg: 'Mas quem é que você pensa que eu sou?', isSent: true },
                { senderImg: 'avatar-s-5.png', msg: 'Tenha calma minha linda Maria, apenas cortesia da recepção.', isSent: false },
                { senderImg: 'avatar-s-2.png', msg: 'O meu nome não é Maria!', isSent: true },
                { senderImg: 'avatar-s-5.png', msg: 'E também não é nada linda!', isSent: false },
            ],
            news_info: []
        }
    },
    computed: {
    	user_first_last_name: function() {
    		return this.$user.name.split(/(\s).+\s/).join("");
    	}
    },
	methods: {
		getUserHotel() {
			let self = this;
			// Get the user hotel location

			axios({
				method: 'get',
				url: themeConfig.apiurl + '/myvilagale/user/userhotel',
				params: {
					token: this.$user.usertoken,
					userId: this.$user.id,
				},
				headers: {
					Authorization: 'Bearer ' + this.$user.usertoken
				}
			})
			.then(function (res) {
				self.user_hotel = localStorage.getItem('user_hotel');
				self.user_hotel_name = self.user_hotel[0].hvg_nome; 
				
				// Still not sure I will need this, it stays for now
				// localStorage.setItem('user_hotel', self.user_hotel_name);

				// Get images for the scrollers
				self.getCorporateImages();

				// Get current user stay if there's one
				self.getCurrentStay();
			})
			.catch ( function (err) {
			})
		},
		getCorporateImages() {
			let self = this;

			axios({
				method: 'get',
				url: themeConfig.apiurl + '/myvilagale/corporate-images',
				headers: {
					Authorization: 'Bearer ' + this.$user.usertoken
				}
			})

			.then(function (res) {

				self.corporate_images = res.data;
			})
		},
		getHotelImages(hotel) {
			let self = this;

			this.$api({
				method: 'get',
				url: themeConfig.apiurl + '/myvilagale/hotel-images',
				headers: {
					Authorization: 'Bearer ' + this.$user.usertoken
				},
				params: {
					new_hotel: hotel
				}
			})

			.then(function (res) {

				self.hotel_images = res.data;
			})
		},
		getCurrentStay() {
			let that = this;

			let userSession = window.localStorage.getItem('userSession') ? JSON.parse(window.localStorage.getItem('userSession')) : false;
			
			this.$api({
				method: 'get',
				url: themeConfig.apiurl + '/myvilagale/myvilagale/current-stays',
				params: {
					token: this.$user.usertoken,
					user_id: userSession.id,
				},
				headers: {
					Authorization: 'Bearer ' + this.$user.usertoken
				}
			})

			.then(function (res) {

				that.current_stay = res.data;

				if (that.current_stay[0]) {
					localStorage.setItem('current_stay', JSON.stringify(that.current_stay[0]));
				}
			})
			
			.catch ( function (err) {
				that.failure_message = "Erro a obter estadias.";	
			})
		},

		hidePopup() {
			this.welcome_template_tmp = false;

			window.localStorage.setItem('hidePopup', false);

			this.welcome_popup = JSON.parse(window.localStorage.getItem('hidePopup'));
		},
		getList() {
                this.$vs.loading();
                this.$api.post( '/myvilagale/news/getList?token=' + this.$user.usertoken,
                {
                    view: 'home',
                    user: this.$user,
                    is_staff: this.$user.is_staff,
                    language: this.$i18n.locale.toUpperCase()
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.$user.usertoken
                    }
                })
                .then((res) => {
                    this.$vs.loading.close();
                    this.news_info = res.data;
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
        },
        get_account_val() {
        	this.$api.get( '/myvilagale/get_account_val?token=' + this.$user.usertoken, {params: {num_reserva: this.$user.hotel.num_reserva}})
            .then((res) => {
                this.account_val = res.data.toFixed(2);
            })
            .catch((err) => {
                this.notify(err.response.data.message, 'red', 10);
                this.$vs.loading.close();
            });
        }

	},
	watch: {
		welcome_popup: function(new_val, old_val) {
			if (!new_val) {
				this.welcome_template_tmp = false;
			}
		},
		'$i18n.locale': function(new_val, old_val){
            this.getList();
        }
	},
    components: {
        CarouselMultipleSlidesPerView,
		Weather,
		VuePerfectScrollbar,
		PointsOfInterest,
		WelcomePopup,
		NewsHighlight,
		EventCalendar
	},
	created() {
		if(this.$user.forceLoginChange == 1){
			this.$router.push({ name: 'pageLogin'});
		}
		this.welcome_popup = JSON.parse(window.localStorage.getItem('hidePopup'));
		this.getList();
		this.getCorporateImages();
		if(this.$user.hotel.hotel_id) {
			this.get_account_val();
			this.getHotelImages(this.$user.hotel.hotel_id);
			if(window.localStorage.getItem('hidePopup')) {
				this.welcome_template_tmp = this.$user.hotel.welcome_template;
			}
		}
	},
}
</script>

<style lang="scss">

.carousel-example .swiper-container .swiper-slide {
	text-align: center;
	font-size: 38px;
	font-weight: 700;
	/* background-color: #eee; */
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	height: auto;
	vertical-align: middle;
}

.fe_container {
	height: 198px;
}

.chat-card-log {
	height: 400px;

	.chat-sent-msg {
		background-color: #f2f4f7 !important;
	}
}

.poi {
	width: 65%;
	margin-left: 15px;
	margin-right: 10px;
}

.vs-popup--header {
	background: #63C0BB;
}

.vs-popup--title h3 {
	color: white;
}

#canspamBarWrapper {
	display: none !important;
}

@media (max-width: 640px) {
	.rsv_data.flex {
		display:block !important;
	}

	.rsv_data.flex p {
		margin-top: 15px;
	}
}

@media (max-width: 1790px) {

	.chat_card {
		margin-top: 25px;
		width: 100%;
	}

	.poi {
		width: 100%;
	}
}

/* @media (max-width: 600px) {

	.fe_daily {
		display: none !important;
	}

	body.hide_daily .fe_container {
		min-width: 200px;
	}

	.fe_container {
		width: 100%;
		font-weight: 300;
		min-width: 500px;
		max-width: 1000px;
		color: #333;
		margin: 0 auto;
		height: 245px;
	}
} */
</style>
